<template>
  <div class="user-input" :class="inputClass">
    <div class="input-icon"></div>
    <div class="selected-keyword-list">
      <div v-for="(k, index) in selectedKeywords" class="selected-keyword-wrapper" :key="index">
        <span class="selected-keyword">{{ getSuggestionWord(k) }}</span
        ><a class="remove-keyword" href="#" @click.prevent="removeKeyword(k)">
          <div class="remove-keyword-icon"></div>
        </a>
      </div>
    </div>
    <input
      :placeholder="placeholder"
      ref="userInput"
      type="search"
      :value="input"
      @input="onInputChange"
      @focus="$emit('focus')"
      @blur="onInputBlur"
      @keydown.up.prevent="stop"
      @keydown.down.prevent="stop"
      @compositionstart="onCompositionStart"
      @compositionend="onCompositionEnd"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  props: {
    searchOptions: {
      type: Object,
      default: () => {},
    },
    modalActive: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      composing: false,
    };
  },
  computed: {
    ...mapState('stocksAutocompleteSearch', ['input', 'selectedKeywords']),
    inputClass() {
      return {
        'modal-active': this.modalActive,
      };
    },
  },
  watch: {},
  methods: {
    ...mapActions('stocksAutocompleteSearch', [
      'changeInput',
      'searchKeywords',
      'addKeyword',
      'removeKeyword',
    ]),
    limitText(count) {
      return `和其他 ${count} 個關鍵字`;
    },
    stop() {},
    onInputChange(evt) {
      if (this.composing && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return;
      }
      const input = evt.target.value;
      this.enterSubmit = true;
      this.changeInput(input);
      this.searchKeywords({
        ...this.searchOptions,
        input,
      });
      this.$emit('current-input', input);
    },
    onInputBlur() {
      this.$emit('blur');
    },
    getSuggestionWord(data) {
      const keyword = JSON.parse(data);
      return keyword.suggestionWord;
    },
    onCompositionStart() {
      this.composing = true;
    },
    onCompositionEnd(evt) {
      this.composing = false;

      const input = evt.target.value;
      this.changeInput(input);
      this.searchKeywords({
        ...this.searchOptions,
        input,
      });
    },
  },
};
</script>

<style scoped>
.user-input {
  width: 100%;
  font-size: 16px;
  border: none;
  padding: 6px 16px;
  border-radius: 5px;
  background: #ffffff;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.user-input .input-icon {
  margin-right: 4px;
  width: 20px;
  background-image: url('data:image/svg+xml;utf-8,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5833 17.625L11.0625 12.125C10.6597 12.4723 10.1806 12.7431 9.625 12.9375C9.06945 13.132 8.47917 13.2292 7.85417 13.2292C6.32639 13.2292 5.03125 12.7014 3.96875 11.6459C2.90625 10.5903 2.375 9.31254 2.375 7.81254C2.375 6.31254 2.90625 5.03476 3.96875 3.97921C5.03125 2.92365 6.3125 2.39587 7.8125 2.39587C9.3125 2.39587 10.5903 2.92365 11.6458 3.97921C12.7014 5.03476 13.2292 6.31254 13.2292 7.81254C13.2292 8.40976 13.1319 8.98615 12.9375 9.54171C12.7431 10.0973 12.4583 10.6181 12.0833 11.1042L17.625 16.5834L16.5833 17.625ZM7.83333 11.8125C8.93056 11.8125 9.86458 11.4202 10.6354 10.6355C11.4062 9.85073 11.7917 8.90976 11.7917 7.81254C11.7917 6.71532 11.4062 5.77435 10.6354 4.98962C9.86458 4.2049 8.93056 3.81254 7.83333 3.81254C6.70833 3.81254 5.75694 4.2049 4.97917 4.98962C4.20139 5.77435 3.8125 6.71532 3.8125 7.81254C3.8125 8.90976 4.20139 9.85073 4.97917 10.6355C5.75694 11.4202 6.70833 11.8125 7.83333 11.8125Z" fill="%239A9A9A"/></svg>');
  background-repeat: no-repeat;
  height: 20px;
}

.user-input input,
.user-input input.focus,
.user-input input.active {
  flex: 1;
  width: 100%;
  border: none;
  box-shadow: none;
  outline: none;
  background: #fff;
}

.selected-keyword-list {
  display: flex;
  flex-wrap: wrap;
}

.user-input .selected-keyword-wrapper {
  margin-right: 4px;
  font-size: 14px;
  display: flex;
}

.user-input .selected-keyword-wrapper .selected-keyword {
  background: #ffe100;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 4px 0 4px 8px;
  line-height: 18px;
}

.user-input .selected-keyword-wrapper .remove-keyword .glyphicon {
  font-size: 12px;
  top: 0;
}

.fa-times {
  color: #252525;
}

.user-input .selected-keyword-wrapper .remove-keyword {
  background-color: #ffe100;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 5px 8px;
  display: flex;
  align-items: center;
}

.remove-keyword-icon {
  width: 16px;
  height: 16px;
  background-image: url('data:image/svg+xml;utf-8,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.14922 12.55L3.44922 11.85L7.29922 7.99995L3.44922 4.14995L4.14922 3.44995L7.99922 7.29995L11.8492 3.44995L12.5492 4.14995L8.69922 7.99995L12.5492 11.85L11.8492 12.55L7.99922 8.69995L4.14922 12.55Z" fill="%23252525"/></svg>');
  background-repeat: no-repeat;
}

.user-input .selected-keyword-wrapper .remove-keyword:hover {
  color: #000;
}

.user-input.modal-active,
.user-input.modal-active:focus {
  outline: none;
}

.fa-search {
  color: #9a9a9a;
}
</style>
